export function checkState(condition: boolean, message?: string) {
  if (condition) {
    return;
  }
  throw new Error(message || 'Precondition failed');
}
